interface SMBLogoProps {
  className?: string;
}

export const SMBLogo = ({ className = "w-6 h-6" }: SMBLogoProps) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.9995 6.16489L0.00012207 9.08278V6.36043C0.00012207 4.53312 1.25045 2.94267 3.02542 2.51167L11.9995 0.329102V6.16489Z" fill="black"/>
      <path d="M3.02542 15.6535L11.9995 17.836V12.0002L0.00012207 9.08234V11.8047C0.00012207 13.632 1.25045 15.2224 3.02542 15.6535Z" fill="black"/>
      <path d="M12.0035 17.8347L24.0027 14.9169V17.6392C24.0027 19.4665 22.7525 21.057 20.9775 21.488L12.0035 23.6706V17.8347Z" fill="black"/>
      <path d="M20.9775 8.34577L12.0035 6.16321V11.9989L24.0028 14.9169V12.1946C24.0028 10.3673 22.7525 8.77678 20.9775 8.34577Z" fill="black"/>
    </svg>
  );
};